module.exports = __webpack_public_path__ + "img/tg-2.63a39e39.png";